import type React from 'react';

function PostnordLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 163.2 30.85"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Postnord Logo</title>

      <g id="Lager_1" data-name="Lager 1">
        <g id="Lager_2" data-name="Lager 2">
          <g id="Lager_1-2" data-name="Lager 1-2">
            <path
              d="M0,5.9c2,0,4,.1,6,0,1,0,1.3,.2,1.2,1.2v.5c1-1,2.3-1.7,3.7-2,4.8-1.3,9.7,1.6,11,6.4,.1,.5,.2,1,.3,1.4,.6,3-.1,6.1-1.9,8.6-3.1,4-8.8,4.9-13,2.1v6.6h-.5c-.3-.3-.6-.2-1-.2H0V5.9ZM14.7,15.5c.1-2.1-1.5-3.8-3.6-3.9h-.3c-2.1,0-3.8,1.6-3.9,3.7v.3c0,2.1,1.6,3.9,3.7,3.9h.3c2.1,0,3.8-1.7,3.8-3.7v-.3Z"
              fill="inherit"
            />
            <path
              d="M163.2,25.2c-2,0-4-.1-6,0-1,0-1.3-.2-1.2-1.2v-.4c-.1,0-.2,0-.3,.1-5.7,4.5-13.5,1.4-14.6-5.8-.7-3.4,.2-6.9,2.4-9.5,3.3-3.4,8.5-4,12.5-1.4V2.3c0-.6,.1-1,.9-1.1l6.3-1.2V25.2Zm-7-9.6c0-2.1-1.7-3.9-3.8-3.9s-3.9,1.7-3.9,3.8c-.1,2.1,1.5,3.9,3.6,4h.3c2.1,.1,3.8-1.4,4-3.5-.2-.1-.2-.3-.2-.4h0Z"
              fill="inherit"
            />
            <path d="M0,30.6H5.9c.3,0,.7-.1,1,.2H.5c-.2,0-.5,.2-.5-.2Z" fill="inherit" />
            <path
              d="M35,5.3c3.4,.1,6.6,.9,9,3.5,4.9,5.4,2.1,14.4-5.1,16.4-2.8,.8-5.7,.8-8.4-.1-4.4-1.4-6.9-4.7-7-9.1-.1-4.9,2.3-8.4,6.8-9.9,.7-.2,1.3-.4,2-.5,.8-.2,1.8-.3,2.7-.3Zm-.1,6.3c-2.1-.1-3.8,1.5-3.9,3.6v.4c-.1,2.1,1.5,3.9,3.6,3.9h.3c2,.1,3.8-1.5,3.8-3.6v-.3c.2-2-1.3-3.8-3.4-4h-.4Z"
              fill="inherit"
            />
            <path
              d="M114,5.3c2.8-.1,5.6,.8,7.8,2.5,4.8,3.6,4.7,12.7-.9,16-4.1,2.6-9.3,2.8-13.5,.5-3.7-1.9-5.2-5.1-5-9.2,0-3.8,2.3-7.2,5.9-8.6,1.8-.9,3.7-1.2,5.7-1.2Zm-4,10.2c-.1,2.1,1.5,3.9,3.5,4h.4c2.1,.1,3.8-1.5,3.9-3.6v-.3c.1-2.1-1.5-4-3.6-4.1s-4,1.5-4.1,3.6c-.1,.2-.1,.3-.1,.4h0Z"
              fill="inherit"
            />
            <path
              d="M88,7.6c2.5-2.5,5.3-2.8,8.3-1.9,2.6,.7,4.3,3.1,4.4,6.3,.1,4.2,0,8.4,.1,12.6,0,.5-.2,.6-.7,.6h-5.8c-.6,0-.8-.2-.8-.8V15c0-.3,0-.7-.1-1-.3-1.6-1-2.2-2.3-2.2-1.4-.2-2.8,.7-3,2.1h0c-.1,.5-.1,1-.1,1.5v8.9c0,.8-.2,.9-.9,.9h-5.5c-.6,0-.7-.1-.7-.7V6.6c0-.6,.2-.7,.7-.7h5.4c.8,0,1.2,.2,1,1v.7Z"
              fill="inherit"
            />
            <path
              d="M57.5,5.4c2.1,0,4.3,.2,6.4,.6,.5,.1,.6,.3,.5,.8-.4,1.4-.7,2.8-1,4.2-.1,.5-.2,.6-.7,.4-2-.7-4.2-1-6.3-.8h-.5c-.6,.1-1.3,.2-1.3,1s.7,.8,1.2,.9c1.3,.2,2.7,.4,4.1,.7,.6,.1,1.1,.3,1.7,.5,2.3,.8,3.7,2.3,3.8,4.8,.2,2.3-1,4.6-3.1,5.6-2.8,1.5-5.9,1.6-9,1.5-1.9-.1-3.7-.4-5.5-.9-.6-.1-.8-.3-.6-.9,.4-1.4,.7-2.8,1.1-4.2,.1-.5,.3-.8,.9-.5,1.9,.8,3.9,1.2,5.9,1.3,.7,.1,1.4,0,2.1-.2,.4-.1,.8-.5,.8-.9s-.4-.8-.8-.8c-.8-.2-1.6-.3-2.4-.4-1.3-.2-2.7-.5-3.9-.9-1.9-.7-3.3-1.9-3.5-4-.4-2.2,.5-4.4,2.2-5.7,1.9-1.3,4.2-2,6.5-2,.3-.2,.8-.1,1.4-.1Z"
              fill="inherit"
            />
            <path
              d="M80.4,5.9c-1.1,2-2.1,3.9-3.1,5.7-.1,.2-.4,.4-.7,.3h-1.9c-.6,0-.9,.1-.9,.9v11.3c0,.9-.2,1.1-1.1,1.1-1.7-.1-3.4,0-5.2,0-.7,0-.9-.1-.9-.9V2.4c0-.6,.2-.8,.8-.8h5.6c.6,0,.8,.1,.7,.7v2.8c0,.6,.2,.8,.8,.8h5.9Z"
              fill="inherit"
            />
            <path
              d="M134.1,8c1.6-2.1,3.7-2.4,6-2.3,.6,0,.8,.2,.8,.8-.1,1.6-.1,3.3-.1,5,0,.6-.1,1-.9,.8-.9-.2-1.8-.2-2.8-.1-1.8,.1-3.1,1.7-3,3.5v8.7c0,.8-.2,.9-.9,.9h-5.5c-.6,0-.7-.1-.7-.7V6.7c0-.6,.2-.7,.7-.7h5.5c.7,0,1,.2,.9,.9v1.1Z"
              fill="inherit"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default PostnordLogo;
